/* 30.10.2026 PDP-schlank: Sections mit Platzhalter (snippets/sk-lazy-section.liquid) erst kurz vor dem Sichtbarwerden laden.
   Holt die Section per Section Rendering API, ersetzt den Inhalt der .shopify-section und meldet 'shopify:section:load'
   (Empire initialisiert Slider/Lazy-Bilder wie im Theme-Editor). Fehlschlag: Platzhalter bleibt leer (keine Fehlermeldung). */
(function () {
  if (window.__skLazySections) return;
  window.__skLazySections = 1;
  function load(ph) {
    if (ph.__skLoading) return; ph.__skLoading = 1;
    var wrap = ph.closest('.shopify-section') || ph.parentNode;
    var id = ph.getAttribute('data-sk-lazy-section');
    fetch(ph.getAttribute('data-src'), { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error(r.status); return r.text();
    }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var src = tmp.querySelector('.shopify-section') || tmp;
      if (src.querySelector('[data-sk-lazy-section]')) throw new Error('placeholder');
      wrap.innerHTML = src.innerHTML;
      try { wrap.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: id } })); } catch (e) {}
    }).catch(function () {
      /* einmal nach kurzer Pause erneut versuchen (z. B. kurzer Netzaussetzer), danach Platzhalter einklappen */
      if (!ph.__skRetried) { ph.__skRetried = 1; ph.__skLoading = 0; setTimeout(function () { load(ph); }, 1500); return; }
      ph.removeAttribute('aria-busy'); ph.style.minHeight = '0';
    });
  }
  function init() {
    var phs = document.querySelectorAll('[data-sk-lazy-section]');
    if (!phs.length) return;
    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(phs, load); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); load(e.target); } });
    }, { rootMargin: '1200px 0px' });
    Array.prototype.forEach.call(phs, function (p) { io.observe(p); });
  }
  /* Tab-Inhalte (z. B. Bewertungsliste in sk-product-tabs): erst beim Öffnen des Tabs/Akkordeons holen */
  var tabCache = {};
  function loadTab(ph) {
    if (ph.__skLoading) return; ph.__skLoading = 1;
    var pid = ph.getAttribute('data-sk-ptab-lazy'), url = ph.getAttribute('data-src');
    var req = tabCache[url] || (tabCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }));
    req.then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var src = tmp.querySelector('[id="' + pid + '"] .sk-ptabs__content');
      if (!src || src.querySelector('[data-sk-ptab-lazy]')) throw new Error('missing');
      var box = ph.parentNode; box.removeChild(ph);
      while (src.firstChild) box.appendChild(src.firstChild);
    }).catch(function () { ph.__skLoading = 0; ph.removeAttribute('aria-busy'); });
  }
  function tabTrigger(e) {
    var t = e.target && e.target.closest && e.target.closest('[aria-controls]');
    if (!t) return;
    var ph = document.querySelector('[data-sk-ptab-lazy="' + t.getAttribute('aria-controls') + '"]');
    if (ph) loadTab(ph);
  }
  ['click', 'pointerenter', 'focusin'].forEach(function (n) { document.addEventListener(n, tabTrigger, { capture: true, passive: true }); });
  function initTabs() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sk-ptab-lazy]'), function (ph) { if (ph.offsetParent !== null) loadTab(ph); });
  }
  /* Bewertungsliste (sections/judgeme-reviews): „Mehr Bewertungen anzeigen“ – lädt beim ersten Bedarf die vollständige Liste
     (Section Rendering), danach je Klick 10 weitere sichtbar. Umschalter „Beste zuerst / Neueste / Kritische zuerst“ sortiert
     clientseitig über data-r (Sterne), data-t (mit Text), data-d (Datum); danach wieder 10 sichtbar (30.10.2026). */
  var RV_STEP = 10;
  var rvFull = null;
  function rvDst() { return document.getElementById('sk-reviews-list'); }
  function rvMoreWrap() { return document.querySelector('.sk-reviews__more-wrap'); }
  function rvSync() {
    var dst = rvDst(), wrap = rvMoreWrap();
    if (wrap) wrap.hidden = !!(dst && rvFull && !dst.querySelector(':scope > [data-sk-rv-hidden]'));
  }
  function rvLoadFull(src) {
    if (rvFull) return rvFull;
    var dst = rvDst();
    rvFull = fetch(src, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var s = tmp.querySelector('#sk-reviews-list');
      if (!s || !dst) throw new Error('missing');
      var n = dst.children.length, items = Array.prototype.slice.call(s.children, n);
      items.forEach(function (it) { it.setAttribute('hidden', ''); it.setAttribute('data-sk-rv-hidden', ''); dst.appendChild(it); });
    }).catch(function (e) { rvFull = null; throw e; });
    return rvFull;
  }
  function revealReviews(focus) {
    var dst = rvDst(); if (!dst) return;
    var hidden = dst.querySelectorAll(':scope > [data-sk-rv-hidden]');
    for (var i = 0; i < hidden.length && i < RV_STEP; i++) {
      hidden[i].removeAttribute('hidden'); hidden[i].removeAttribute('data-sk-rv-hidden');
      if (focus && i === 0) { hidden[i].setAttribute('tabindex', '-1'); hidden[i].focus({ preventScroll: true }); }
    }
    rvSync();
  }
  function rvSort(mode) {
    var dst = rvDst(); if (!dst) return;
    var items = Array.prototype.slice.call(dst.children);
    var num = function (el, a) { return parseFloat(el.getAttribute(a)) || 0; };
    var date = function (el) { return el.getAttribute('data-d') || ''; };
    items.sort(function (a, b) {
      if (mode === 'newest') return date(b).localeCompare(date(a));
      if (mode === 'critical') return (num(a, 'data-r') - num(b, 'data-r')) || (num(b, 'data-t') - num(a, 'data-t')) || date(b).localeCompare(date(a));
      return (num(b, 'data-r') - num(a, 'data-r')) || (num(b, 'data-t') - num(a, 'data-t')) || date(b).localeCompare(date(a));
    });
    items.forEach(function (it, i) {
      dst.appendChild(it);
      if (i < RV_STEP) { it.removeAttribute('hidden'); it.removeAttribute('data-sk-rv-hidden'); }
      else { it.setAttribute('hidden', ''); it.setAttribute('data-sk-rv-hidden', ''); }
    });
    rvSync();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-sk-reviews-more]');
    if (!btn || btn.disabled) return;
    if (rvFull) { rvFull.then(function () { revealReviews(true); }); return; }
    btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    rvLoadFull(btn.getAttribute('data-src')).then(function () {
      btn.disabled = false; btn.removeAttribute('aria-busy');
      var sel = document.querySelector('[data-sk-reviews-sort]');
      if (sel && sel.value !== 'best') rvSort(sel.value);
      revealReviews(true);
    }).catch(function () { btn.disabled = false; btn.removeAttribute('aria-busy'); });
  });
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-sk-reviews-sort]');
    if (!sel) return;
    sel.disabled = true;
    rvLoadFull(sel.getAttribute('data-src')).then(function () { rvSort(sel.value); }).catch(function () {}).then(function () { sel.disabled = false; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initTabs(); }); else { init(); initTabs(); }
})();
